import { Adapter } from '@wix/app-settings-client/dist/src/domain'
import { appClient, Scope } from '@wix/app-settings-client'
import { MetricsReporter } from '@wix/thunderbolt-becky-types'

export class AppSettings implements Adapter {
	appDefId: string
	instanceId: string
	externalId: string
	signedInstance: any

	constructor({ appDefId, instanceId, externalId }: { appDefId: string; instanceId: string; externalId: string }) {
		this.appDefId = appDefId
		this.instanceId = instanceId
		this.externalId = externalId
	}

	getAppDefId(): string {
		return this.appDefId
	}

	getInstanceId(): string {
		return this.instanceId
	}

	async getExternalId(): Promise<string> {
		return this.externalId
	}

	async setExternalId(_id: string): Promise<void> {}

	triggerSettingsUpdated(_data: any, _scope: Scope): void {}

	onSettingsUpdated(_scope: Scope, _cb: (k: object) => void): void {}
}

export const resolveAppSettings = async (
	referenceId: string,
	applicationId: string,
	instanceId: string,
	metricsReporter: MetricsReporter
) => {
	return metricsReporter.runAsyncAndReport(async () => {
		try {
			const appSettings = appClient({
				scope: Scope.COMPONENT,
				adapter: new AppSettings({
					appDefId: applicationId,
					instanceId,
					externalId: referenceId,
				}),
			})
			return appSettings.getAll()
		} catch (e) {
			metricsReporter.reportError(
				new Error(
					`Failed to get app settings for appDefId: ${applicationId} with externalId: ${referenceId} and instanceId:s ${instanceId}, error: ${e}`
				)
			)
		}
	}, 'app settings fetcher')
}
